import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Scene from "../components/Scene/Scene";
import Loading from "../components/Loading/Loading";
import yescatImg from "../assets/yescat.png";

const WRONG_LINES = [
  "WROOOGNGONGNGGG!!!! TRYY AGAIINNN",
  "wrong button.",
  "ts serious lock in",
  "nuh uh :(",
  "WRONGGG!!! TRYY AGAIIN",
];

const CONFETTI_COLORS = [
  "#00b4ff", "#00e5ff", "#40c4ff", "#80d8ff",
  "#00e676", "#69f0ae", "#b2ff59", "#00c853",
];

const confettiPieces = Array.from({ length: 80 }, (_, i) => {
  const duration = 2.5 + Math.random() * 2;
  return {
    id: i,
    left: Math.random() * 100,
    delay: -(Math.random() * duration),
    duration,
    width: 6 + Math.random() * 6,
    height: 10 + Math.random() * 8,
    color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
  };
});

const EarthDay = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [gameState, setGameState] = useState("intro");
  const [showSmoke, setShowSmoke] = useState(false);
  const [wrongKey, setWrongKey] = useState(0);
  const [sceneKey, setSceneKey] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  const handleYesCatClick = () => setGameState("growing");

  const [paradePhase, setParadePhase] = useState("idle"); // idle | walkin | walkoff

  const handleGrowEnd = () => {
    setShowSmoke(true);
    setGameState("parading");
    setParadePhase("walkin");
    setTimeout(() => setShowSmoke(false), 1200);
  };

  // called when the last little cat finishes walking in
  const handleLittleCatsArrived = () => {
    setParadePhase("walkoff");
  };

  // called when the walk-off animation ends (big cat leads, triggers first)
  const handleWalkOffEnd = () => {
    setGameState("celebrating");
    setParadePhase("idle");
  };

  const handleRestart = () => {
    setGameState("intro");
    setShowSmoke(false);
    setWrongKey(0);
    setSceneKey((k) => k + 1);
  };

  const celebrating = gameState === "celebrating";
  const parading = gameState === "parading";

  // 4 little cats spaced out to the right of center, walk in behind big cat
  // big cat center is at 50vw; each little cat is ~14vmin wide, offset from there
  const LITTLE_CAT_SIZE = "14vmin";
  const littleCats = [0, 1, 2, 3];

  return (
    <div
      id="canvas-container"
      style={{ width: "100vw", height: "100vh", position: "relative" }}
    >
      <Link
        to="/"
        style={{
          position: "absolute",
          top: "1.5rem",
          left: "1.5rem",
          zIndex: 30,
          fontFamily: "'DynaPuff', cursive",
          fontSize: "0.85rem",
          color: "#fff",
          background: "rgba(0,0,0,0.35)",
          border: "1px solid rgba(255,255,255,0.5)",
          borderRadius: "999px",
          padding: "0.5rem 1.1rem",
          textDecoration: "none",
          textShadow: "0 1px 4px rgba(0,0,0,0.7)",
        }}
      >
        back to us
      </Link>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {/* Globe — always visible (stars only on intro) */}
          <Scene
            key={sceneKey}
            onNoCatClick={() => setWrongKey((k) => k + 1)}
            onYesCatClick={handleYesCatClick}
            hideYesCat={gameState !== "playing"}
            hideEarth={gameState === "intro"}
          />

          {/* Intro screen */}
          {gameState === "intro" && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "2rem",
                zIndex: 10,
              }}
            >
              <h1
                style={{
                  fontFamily: "'DynaPuff', cursive",
                  fontSize: "clamp(1.6rem, 5vw, 3.5rem)",
                  color: "#fff",
                  textShadow:
                    "0 0 18px rgba(0,180,255,0.9), 0 0 32px rgba(0,255,120,0.7), 0 2px 8px rgba(0,0,0,0.7)",
                  userSelect: "none",
                  textAlign: "center",
                }}
              >
                Happy Earth Day!
              </h1>
              <button
                onClick={() => setGameState("playing")}
                style={{
                  fontFamily: "'DynaPuff', cursive",
                  fontSize: "clamp(1.4rem, 3.5vw, 2.4rem)",
                  color: "#fff",
                  background: "transparent",
                  border: "2px solid rgba(255,255,255,0.5)",
                  borderRadius: "50%",
                  width: "clamp(70px, 10vw, 100px)",
                  height: "clamp(70px, 10vw, 100px)",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingLeft: "0.3em",
                  boxShadow:
                    "0 0 18px rgba(0,180,255,0.5), 0 0 32px rgba(0,255,120,0.3)",
                }}
              >
                ▶
              </button>
            </div>
          )}

          {/* Title (shown during gameplay) */}
          {gameState !== "intro" && (
          <h1
              style={{
                position: "absolute",
                top: "8%",
                width: "100%",
                textAlign: "center",
                fontFamily: "'DynaPuff', cursive",
                fontSize: "clamp(1.4rem, 4vw, 3rem)",
                color: "#fff",
                textShadow:
                  "0 0 18px rgba(0,180,255,0.9), 0 0 32px rgba(0,255,120,0.7), 0 2px 8px rgba(0,0,0,0.7)",
                pointerEvents: "none",
                userSelect: "none",
              }}
            >
              Will you be my whole world?
            </h1>
          )}

          {/* Wrong text */}
          {wrongKey > 0 && gameState === "playing" && (
            <p
              key={wrongKey}
              style={{
                position: "absolute",
                bottom: "8%",
                width: "100%",
                textAlign: "center",
                fontFamily: "'DynaPuff', cursive",
                fontSize: "clamp(1rem, 3vw, 2rem)",
                color: "#ff4444",
                textShadow:
                  "0 0 14px rgba(255,50,50,0.9), 0 2px 8px rgba(0,0,0,0.7)",
                pointerEvents: "none",
                userSelect: "none",
                animation: "wrongFadeOut 2s forwards",
              }}
            >
              {WRONG_LINES[(wrongKey - 1) % WRONG_LINES.length]}
            </p>
          )}

          {/* Confetti — starts when yes is clicked, keeps falling */}
          {(gameState === "growing" || gameState === "parading" || gameState === "celebrating") && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                pointerEvents: "none",
                zIndex: 15,
              }}
            >
              {confettiPieces.map((p) => (
                <div
                  key={p.id}
                  style={{
                    position: "absolute",
                    left: `${p.left}%`,
                    top: 0,
                    width: p.width,
                    height: p.height,
                    backgroundColor: p.color,
                    borderRadius: "2px",
                    animation: `confettiFall ${p.duration}s ${p.delay}s infinite linear`,
                  }}
                />
              ))}
            </div>
          )}

          {/* Growing yescat overlay */}
          {gameState === "growing" && (
            <img
              src={yescatImg}
              alt=""
              onAnimationEnd={handleGrowEnd}
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                width: "55vmin",
                height: "55vmin",
                objectFit: "contain",
                animation: "growCat 1.5s ease-out forwards",
                pointerEvents: "none",
                zIndex: 10,
              }}
            />
          )}

          {/* Smoke puff */}
          {showSmoke && (
            <div
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                width: "55vmin",
                height: "55vmin",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(180,180,180,0.6) 0%, transparent 70%)",
                filter: "blur(10px)",
                animation: "smokePuff 1.2s ease-out forwards",
                pointerEvents: "none",
                zIndex: 5,
              }}
            />
          )}

          {/* Parade — big cat stays centered, little cats walk in, then all walk off left */}
          {parading && (
            <>
              {/* Per-cat keyframes: walk-in to parked spot, then walk-off from that spot */}
              <style>{`
                @keyframes bigCatWalkOff {
                  from { transform: translateX(calc(50vw - 27.5vmin)); }
                  to   { transform: translateX(-140vw); }
                }
                ${[0, 1, 2, 3].map((i) => {
                  const parkVmin = ([0, 1, 2, 3].length - i) * 16;
                  return `
                    @keyframes littleCatWalkIn-${i} {
                      from { transform: translateX(110vw); }
                      to   { transform: translateX(calc(50vw + ${parkVmin}vmin)); }
                    }
                    @keyframes littleCatWalkOff-${i} {
                      from { transform: translateX(calc(50vw + ${parkVmin}vmin)); }
                      to   { transform: translateX(-140vw); }
                    }
                  `;
                }).join("")}
              `}</style>

              {/* Big cat — left:0, centered via translateX so walk-off keyframe chains cleanly */}
              <img
                src={yescatImg}
                alt=""
                onAnimationEnd={paradePhase === "walkoff" ? handleWalkOffEnd : undefined}
                style={{
                  position: "absolute",
                  left: 0,
                  top: "50%",
                  marginTop: "-27.5vmin",
                  width: "55vmin",
                  height: "55vmin",
                  objectFit: "contain",
                  pointerEvents: "none",
                  zIndex: 20,
                  transform: "translateX(calc(50vw - 27.5vmin))",
                  ...(paradePhase === "walkoff" && {
                    animation: "bigCatWalkOff 1.4s ease-in forwards",
                  }),
                }}
              />

              {/* 4 little cats walk in from the right */}
              {littleCats.map((i) => {
                // Cats start off-screen right. left:0, start translateX at 110vw,
                // walk to their park spot just to the right of the big cat.
                // parkX: 50vw + (cats.length - i) * 16vmin  (i=0 is farthest back)
                const startX = "110vw";
                const delay = i * 0.25;

                return (
                  <img
                    key={i}
                    src={yescatImg}
                    alt=""
                    onAnimationEnd={
                      paradePhase === "walkin" && i === littleCats.length - 1
                        ? handleLittleCatsArrived
                        : undefined
                    }
                    style={{
                      position: "absolute",
                      left: 0,
                      top: "50%",
                      marginTop: "-7vmin",
                      width: LITTLE_CAT_SIZE,
                      height: LITTLE_CAT_SIZE,
                      objectFit: "contain",
                      pointerEvents: "none",
                      zIndex: 19 - i,
                      ...(paradePhase === "walkin" && {
                        transform: `translateX(${startX})`,
                        animation: `littleCatWalkIn-${i} 1s ${delay}s ease-out forwards, catBob 0.3s ${delay}s infinite`,
                      }),
                      ...(paradePhase === "walkoff" && {
                        animation: `littleCatWalkOff-${i} 1.4s ${0.05 * (i + 1)}s ease-in both, catBob 0.3s infinite`,
                      }),
                    }}
                  />
                );
              })}
            </>
          )}

          {/* Celebration text — appears as soon as cat starts growing */}
          {(gameState === "growing" || gameState === "parading" || celebrating) && (
            <>
              <p
                style={{
                  position: "absolute",
                  bottom: "11%",
                  width: "100%",
                  textAlign: "center",
                  fontFamily: "'DynaPuff', cursive",
                  fontSize: "clamp(1.2rem, 3.5vw, 2.5rem)",
                  color: "#fff",
                  textShadow:
                    "0 0 18px rgba(0,180,255,0.9), 0 0 36px rgba(0,255,120,0.7), 0 2px 8px rgba(0,0,0,0.8)",
                  pointerEvents: "none",
                  userSelect: "none",
                  zIndex: 20,
                }}
              >
                PURRRRRFFECTCTTTTTTT!!!!!!!!!!!
              </p>
              <button
                onClick={handleRestart}
                style={{
                  position: "absolute",
                  bottom: "4%",
                  left: "50%",
                  transform: "translateX(-50%)",
                  fontFamily: "'DynaPuff', cursive",
                  fontSize: "clamp(0.8rem, 2vw, 1.2rem)",
                  color: "#fff",
                  background: "transparent",
                  border: "2px solid rgba(255,255,255,0.5)",
                  borderRadius: "2rem",
                  padding: "0.4rem 1.4rem",
                  cursor: "pointer",
                  textShadow: "0 1px 4px rgba(0,0,0,0.7)",
                  userSelect: "none",
                  zIndex: 20,
                }}
              >
                Agree again?
              </button>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default EarthDay;
